<template>
  <div class="wrap"
       v-bind:class="{
        }"
  >
    <header class="lnbWrap">
      <div class="logo">
        <h1 id="logo">
          <template
          >
            <router-link to="/" title="">
              <img src="@/images/safetyadm/logo.png" class="logImg"/>
            </router-link>
          </template>
        </h1>
      </div>
      <div class="lnbMenu">
        <nav class="nav_menu">
          <ul class="lnb" id="lnbBox">

            <li class="depth_1 hasSub">
              <a href="#" class="slide_btn hasSub icon_2"
                 v-bind:class="{
                    on : currentMenu === 'Member' || currentMenu === 'Admin'
                }"
              >
                <span>회원관리</span>
              </a>
              <ul class="lnbSub" style="display:none;">
                <li
                  class="depth_2"
                  v-on:click="miniStatus"
                >
                  <router-link
                    v-bind:to="`/member`"
                    v-bind:class="{
                      on: currentMenu === 'Member'
                    }"
                    v-on:click="miniStatus"
                  >
                    <span class="bgNone">일반회원</span>
                  </router-link>
                </li>
                <li
                  class="depth_2"
                  v-on:click="miniStatus"
                >
                  <router-link
                    v-bind:to="`/admin`"
                    v-bind:class="{
                      on: currentMenu === 'Admin'
                    }"
                    v-on:click="miniStatus"
                  >
                    <span class="bgNone">관리자회원</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="depth_1"
                v-bind:class="{on : currentMenu === 'License'}"
            >
              <router-link to="/license" class="shopping-bag">
                <span class="bgNone">라이센스관리</span>
              </router-link>
            </li>
            <!-- <li class="depth_1"
                v-bind:class="{on : currentMenu === 'Method'}"
            >
              <router-link to="/method" class="icon_5">
                <span class="bgNone">사용법</span>
              </router-link>
            </li>

            <li class="depth_1"
                v-bind:class="{on : currentMenu === 'Safety'}"
            >
              <router-link to="/help" class="icon_4">
                <span class="bgNone">안전정보</span>
              </router-link>
            </li> -->
            <!-- <li class="depth_1"
                v-bind:class="{on : currentMenu === 'Example'}"
            >
              <router-link to="/examples" class="icon_4">
                <span class="bgNone">활용사례</span>
              </router-link>
            </li> -->
            <li class="depth_1 hasSub">
              <a href="#" class="slide_btn hasSub icon_2"
                 v-bind:class="{
                    on : currentMenu === 'Agree' || currentMenu === 'Policy' || currentMenu === 'PositionAgree'
                }"
              >
                <span>세팅</span>
              </a>
              <ul class="lnbSub" style="display:none;">
                <!--<li
                  class="depth_2"
                  v-on:click="miniStatus"
                >
                  <router-link
                    v-bind:to="`/location`"
                    v-bind:class="{
                      on: currentMenu === 'location'
                    }"
                    v-on:click="miniStatus"
                  >
                    <span>위치정보</span>
                  </router-link>
                </li>
                <li
                  class="depth_2"
                  v-on:click="miniStatus"
                >
                  <router-link
                    v-bind:to="`/memberLog`"
                    v-bind:class="{
                      on: currentMenu === 'MemberLog'
                    }"
                    v-on:click="miniStatus"
                  >
                    <span>관리자 로그</span>
                  </router-link>
                </li>-->
                <li
                  class="depth_2"
                  v-on:click="miniStatus"
                >
                  <router-link
                    v-bind:to="`/setting/agree`"
                    v-bind:class="{
                      on: currentMenu === 'Agree'
                    }"
                    v-on:click="miniStatus"
                  >
                    <span>이용약관</span>
                  </router-link>
                </li>
                <li class="depth_2" v-on:click="miniStatus">
                  <router-link
                    v-bind:to="`/setting/policy`"
                    v-bind:class="{
                      on: currentMenu === 'Policy'
                    }"
                  >
                    <i class="i_icon i_device_op"></i>
                    <span>개인정보 처리방침</span>
                  </router-link>
                </li>
                <li class="depth_2" v-on:click="miniStatus">
                  <router-link
                    v-bind:to="`/setting/position`"
                    v-bind:class="{
                      on: currentMenu === 'PositionAgree'
                    }"
                  >
                    <i class="i_icon i_device_op"></i>
                    <span>위치기반 서비스</span>
                  </router-link>
                </li>
              </ul>
            </li>

            <li class="depth_1 hasSub">
              <a href="#" class="slide_btn hasSub icon_6"
                 v-bind:class="{
                    on : currentMenu === 'Notice' || currentMenu === 'Faq'
                }"
              >
                <span>게시판</span>
              </a>
              <ul class="lnbSub" style="display:none;">
                <li
                  class="depth_2"
                  v-on:click="miniStatus"
                >
                  <router-link
                    v-bind:to="`/board/notice`"
                    v-bind:class="{
                      on: currentMenu === 'Notice'
                    }"
                    v-on:click="miniStatus"
                  >
                    <span>공지사항</span>
                  </router-link>
                </li>
                <li class="depth_2" v-on:click="miniStatus">
                  <router-link
                    v-bind:to="`/board/faq`"
                    v-bind:class="{
                      on: currentMenu === 'Faq'
                    }"
                  >
                    <i class="i_icon i_device_op"></i>
                    <span>FAQ</span>
                  </router-link>
                </li>
                <li class="depth_2" v-on:click="miniStatus">
                  <router-link
                    v-bind:to="`/board/qa`"
                    v-bind:class="{
                      on: currentMenu === 'Qa'
                    }"
                  >
                    <i class="i_icon i_device_op"></i>
                    <span>문의하기</span>
                  </router-link>
                </li>
                <li class="depth_2" v-on:click="miniStatus">
                  <router-link
                    v-bind:to="`/board/qaProduct`"
                    v-bind:class="{
                      on: currentMenu === 'qaProduct'
                    }"
                  >
                    <i class="i_icon i_device_op"></i>
                    <span>제품 문의하기</span>
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- <li class="depth_1"
                v-bind:class="{on : currentMenu === 'Popup'}"
            >
              <router-link to="/popup" class="icon_5">
                <span class="bgNone">팝업관리</span>
              </router-link>
            </li> -->
            <li class="depth_1 hasSub">
              <a href="#" class="slide_btn hasSub icon_5"
                 v-bind:class="{
                    on : currentMenu === 'Alert'
                }"
              >
                <span>안전관리 <div class="slide_btn_image" v-if="alertExist" ></div></span>
              </a>
              <ul class="lnbSub" style="display:none;">
                <li
                  class="depth_2"
                  v-on:click="miniStatus"
                >
                  <router-link
                    v-bind:to="`/safety/alert`"
                    v-bind:class="{
                      on: currentMenu === 'Alert'
                    }"
                    v-on:click="miniStatus"
                  >
                    <span>생산관리 <div class="slide_btn_image" v-if="alertExist" ></div></span>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </header>
    <div class="container lnb">
      <div class="header">
        <div class="h_left">
          <div class="menu_btn menu">
            <a id="menuBtn" href="#"
               v-on:click = "doLeftNavEvent"
            >
              <img src="../images/common/btn_menu_off.jpg" alt="메뉴">
            </a>
          </div>
        </div>
        <div class="h_right util cursor">
          <div class="license" type="text" @click="issued()">라이센스 발급</div>
          <i class="material-icons" @click="logout">
            power_settings_new
          </i>
        </div>
      </div>
    </div>
    <el-dialog
      title="라이센스 발급"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <el-form class="demo-ruleForm">
        <div class="license_wrap">
          <div class="l_div">
            <span class="l_w_span">라이센스 :</span>
            <el-select class="license_input" placeholder="라이센스 선택" v-model="ruleForm.pl_idx">
              <el-option
                v-for="item in filterTypeList"
                :key="item.pl_idx"
                :label="item.pl_title"
                :value="item.pl_idx">
              </el-option>
            </el-select>
          </div>
          <div class="l_div">
            <span class="l_w_span">타이틀 :</span> <el-input class="license_input" v-model="ruleForm.s_title"></el-input>
          </div>
          <div class="l_div">
            <span class="l_w_span">제품분류 :</span>
            <el-select v-model="ruleForm.s_type" placeholder="제품분류 선택">
              <el-option :label="'세이프티씰'" :value="1"></el-option>
              <el-option :label="'세이프티드라이브'" :value="2"></el-option>
                <el-option :label="'세이프티플렉스'" :value="3"></el-option>
            </el-select>
          </div>
          <div class="l_div">
            <span class="l_w_span">수량 :</span>
            <el-input-number   :min="1" :max="1000"  v-model="ruleForm.qty" ></el-input-number>
          </div>
          <!-- <div class="l_div">
            <span class="l_w_span">이메일 :</span> <el-input class="license_input"  v-model="ruleForm.email" ></el-input>
          </div> -->
          <el-button @click="dynamicUpload('ruleForm')"  :disabled="!dynamicLoading">확인</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- 123 -->
  </div>
</template>


<script>
  import sessionStorage from '@/mixins/sessionStorage';
  import localStorage from '@/mixins/localStorage'
  import VuxAlert from '@/mixins/vux-alert';
  let params = {};
  export default {
    components: {},
    name: "PageHeader",
    mixins: [ sessionStorage ,localStorage, VuxAlert ],
    data(){
      return{
        userInfo : this.getUserInfo(),
        lnbStatus : true,
        dialogVisible: false,
        dynamicParams : {
          domainUriPrefix: "https://safetsyi.page.link",
          link: "http://www.pinostory.com",
          androidPackageName : 'com.pinostory.safetsyI',
          androidFallbackLink : 'https://play.google.com/store/apps/details?id=com.pinostory.safetsyI&launch=true',
          enableForcedRedirect : '1',
          iosFallbackLink : 'https://itunes.apple.com/us/app/urbanspoon/id1465731690',
          iosBundleId : 'com.pinostory.safetsyI',
          iosAppStoreId : 'https://itunes.apple.com/us/app/urbanspoon/id1465731690',
          option : 'SHORT',
          product : 'safetsyi',
          pw : 'pinostory12!@'
        },
        ruleForm: {
          s_title: '',
          s_type: 1,
          qty: 1,
          pl_idx: '1',
        },
        dynamicLoading : true,
        filterTypeList: [],
        page : 1,
        alertExist:false,
      }
    },
    created() {
      this.getLicence()
      this.checkAlert();
    },
    computed: {
      metaName(){
        return this.$route.meta.title
      },
      currentMenu() {
        switch(this.$route.meta.name) {
          case 'Method':
          case 'MethodCreate':
          case 'MethodModify':
            return 'Method';

          case 'Safety':
          case 'SafetyCreate':
          case 'SafetyModify':
            return 'Safety';

          case 'Notice':
          case 'NoticeCreate':
          case 'NoticeModify':
            return 'Notice';

          case 'Faq':
          case 'FaqCreate':
          case 'FaqModify':
            return 'Faq';

          case 'Qa':
          case 'QaDetail':
            return 'Qa';

          case 'QaProduct':
          case 'QaProductDetail':
            return 'qaProduct';

          case 'Agree':
          case 'AgreeCreate':
          case 'AgreeModify':
            return 'Agree';

          case 'Policy':
          case 'PolicyCreate':
          case 'PolicyModify':
            return 'Policy';

          case 'PositionAgree':
          case 'PositionAgreeCreate':
          case 'PositionAgreeModify':
            return 'PositionAgree';

          case 'location':
            return 'location';

          case 'MemberLog':
            return 'MemberLog';
          case 'Popup':
          case 'PopupCreate':
          case 'PopupModify':
            return 'Popup'

          case 'Member':
          case 'MemberCreate':
          case 'MemberModify':
            return 'Member';

          case 'Admin':
          case 'AdminCreate':
          case 'AdminModify':
            return 'Admin';

          case 'Product':
            return 'Product';
          case 'License':
          case 'LicenseCreate':
          case 'LicenseModify':
          case 'LicenseProduct':
          case 'LicenseDetail':
            return 'License';

          case 'Alert':
            return 'Alert';

          default:
            return 'Method';
        }
      }
    },

    mounted() {
      this.initData();
      this.doSome(); //네비게이션 메뉴 드롭다운 이벤트
    },

    methods: {
      initData(){
        this.ruleForm = {
          s_title: '',
          s_type: 1,
          qty: 1,
          pl_idx: '1',
        }
      },
      handleClose(done) {

      },
      openModal(name) {
        this.$modal.show(name);
      },
      logout() {
        let $this = this
        this.$vux.confirm.show({
          content: '로그아웃 하시겠습니까?',
          confirmText: "확인",
          cancelText: "취소",
          onConfirm () {
            $this.localLogout();
          }
        });
      },
      miniStatus: function () {
        var lnb = $("#lnbBox")
        if(lnb.hasClass("mini")){
          $(".lnbSub").hide();
        }
      },
      doSome() {
        var lnbMenus = $("#lnbBox .depth_1")
        var lnb = $("#lnbBox")

        lnbMenus.each(function(){
          var $this  =  $(this)
          this.sub  =  $(".lnbSub" , this);
          this.sub$  =  this.sub;
          this.sub = this.sub[0] ? this.sub : null ;
          this.one  =  $(">a" , this);
          this.one[0].li  =  $this;
          this.one[0].sub  =  this.sub;
          if(this.sub){
            this.sub[0].li  =  $this;
            this.sub[0].sub  =  this.sub;
          }
          this.one.status = false;
          this.one.on("click",function(){
            if(this.sub){
              if(this.li.hasClass("on")){
                this.sub.slideToggle();
                lnbMenus.removeClass("on");
              }else{
                $(".lnbSub").hide()
                lnbMenus.removeClass("on");
                this.li.addClass("on");
                this.sub.slideDown();
              }
              return false;
            }else{
              $(".lnbSub").hide()
              lnbMenus.removeClass("on");
              this.li.addClass("on");
            }
          });
          $("section").click(function(){
            if(lnb.hasClass("mini")){
              $(".lnbSub").hide()
            }
          })

          var lnbMenus2 = $("#lnbBox .depth_2")
          lnbMenus2.each(function(){
            this.one  =  $(">a" , this);
            this.one.on("click",function(){
            })
          })

        })
      },
      doLeftNavEvent() {
        $("#lnbBox .lnbSub").hide();
        $("#lnbBox .depth_1 > a").removeClass("on");
        if(this.lnbStatus){
          $(".logImg").hide();
          $("#lnbBox").addClass("mini");
          $(".container").addClass('mini');
          $(".lWrap").addClass('mini_wrap');
          $(".lnbWrap").animate({width:60},200,function(){
            $(".logo h1").css({width:28});
            $("#lnbBox .depth_1 >a").css({width:0})
            $(".lnbMenu").css({width:60})
          })
          $(".container").animate({marginLeft:60},200);
          this.lnbStatus = false;
        }else{
          $(".logImg").show();
          $(".lnbMenu").css({width:210});
          $("#lnbBox .depth_1 >a").css({width:"auto"});
          $("#lnbBox").removeClass("mini");
          $(".container").removeClass('mini');
          $(".lWrap").removeClass('mini_wrap');
          $(".lnbWrap")
            //.css({display:"block"})
            .animate({width:210},200)
          $(".container").animate({marginLeft:210},200,function(){
            $(".logo h1").css({width:210});
          })
          this.lnbStatus = true;
        }
      },
      issued(){
        this.dialogVisible = true;
        this.getLicence();
        this.initData()
      },
      getLicence() {
        params = {
          type : 'pinostory'
        }

        if(this.userInfo.g_idx === 2){
          params.c_idx = this.userInfo.c_idx;
        }else{
          if(this.c_idx){
            params.c_idx = this.c_idx;
          }
        }
        this.$api.$product.getLicenceList(params).then( res => res.Data.Result).then(res => {
          if(res.Info.Type === 1) {
            this.tableData = res.List;
            this.filterTypeList = res.List;
            if(this.filterTypeList.length > 0) {
              this.ruleForm.pl_idx = this.filterTypeList[0].pl_idx;
            }
          }
        })

      },
      dynamicUpload(formName) {
        this.dynamicLoading = false;
        if (this.ruleForm.s_title !== undefined && this.ruleForm.s_title != "" && this.ruleForm.qty !== undefined && this.ruleForm.pl_idx) {
          this.dynamicParams.s_title = this.ruleForm.s_title;
          this.dynamicParams.s_type = this.ruleForm.s_type;
          this.dynamicParams.qty = this.ruleForm.qty;
          // this.dynamicParams.email = this.ruleForm.email;
          this.dynamicParams.pl_idx = this.ruleForm.pl_idx;

          this.$api.$firebase.dynamicAutoUpload(this.dynamicParams).then(res => res.Data.Result).then(res => {
            console.log("res",res)
            if(res.Info.status === true){
              this.createAlert({
                title: "알림",
                content: "라이센스가 발급되었습니다",
                btnText: "확인"
              });
              this.dialogVisible = false;
              this.dynamicLoading = true;
            }else{
              this.createAlert({
                title: "확인",
                content: "라이센스 발급에 실패하였습니다",
                btnText: "확인"
              });
              this.dynamicLoading = true;
            }

          })
        } else {
          this.validateAlert();
          this.dynamicLoading = true;
          return false;
        }
      },
      check() {

        let email = this.ruleForm.email
        let exptext = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-Za-z0-9\-]+/;
        if(exptext.test(email)==false){
          return false;
        }else{
          return true;
        }

      },

      checkAlert() {
        let params = {}
        this.$api.$alert.checkExiseAlert(params).then( res => res.Data.Result).then(res => {
          if(res.Info.Type == 1) {
            this.alertExist = false;
          }else{
            this.alertExist = true;
          }
        })
      },


    },
    watch: {
        '$route': {
            deep: true,
            handler: function (val, oldVal) {
                this.checkAlert();
            }
        },
    },
  }
</script>

<style scoped>

</style>
